import MojitoModules from 'mojito/modules';
import MojitoPresentation from 'mojito/presentation';
import AppOverlayTypes from 'applications/sports/components/app-overlay/types';
import { isEmpty } from 'mojito/utils';
import { renderOverlayItem } from 'applications/common/utils/index.js';

const SimpleToast = MojitoModules.PlayerMessages.ToastMessage.module;
const SelectionsLimitToast = MojitoModules.SelectionsLimitToast;

const AbsolutePane = MojitoPresentation.Components.AbsolutePane;
const { APP_OVERLAY_TOAST_ITEMS } = AppOverlayTypes;
const itemRenderers = {
    [APP_OVERLAY_TOAST_ITEMS.SIMPLE_TOAST]: () => <SimpleToast key={'toast'} />,
    [APP_OVERLAY_TOAST_ITEMS.SELECTIONS_LIMIT_BREACH_TOAST]: () => (
        <SelectionsLimitToast key={'selectionsLimitToast'} />
    ),
};

const ToastOverlay = props => {
    const { config } = props.mojitoTools;
    if (isEmpty(config.items)) {
        return null;
    }
    const elements = config.items.map(item => renderOverlayItem(itemRenderers, item, this));
    return (
        <AbsolutePane class="ta-toastOverlay" config={config.container}>
            {elements}
        </AbsolutePane>
    );
};

export default ToastOverlay;
